import {
	ChangeDetectorRef,
	Component,
	Input, OnDestroy,
	OnInit
} from '@angular/core'
import { MatDialogRef } from '@angular/material'
import { uniqueId } from 'lodash'
import { Subscription } from 'rxjs'
import { AtylDialogConfig } from '../../Interfaces/AtylDialogConfig'
import { DialogService } from '../../services'

@Component({
	selector: 'atyl-dialog-base',
	templateUrl: './dialog-base.component.html',
	styleUrls: ['./dialog-base.component.scss']
})
export class BaseDialogComponent
	implements OnInit, OnDestroy {
	dialogRef: MatDialogRef<BaseDialogComponent>
	dialogService: DialogService
	changeDetectorRef: ChangeDetectorRef
	subscriptions: Subscription[] = []
	config: AtylDialogConfig
	fullScreen = false

	@Input() title:any = ''
	@Input()  subtitle:any = ''

	constructor(
		dialogRef: MatDialogRef<BaseDialogComponent>,
		dialogService: DialogService,
		changeDetectorRef: ChangeDetectorRef
	) {
		this.dialogRef = dialogRef
		this.dialogService = dialogService
		this.changeDetectorRef = changeDetectorRef
	}

	// <- start HOOKS
	ngOnInit(): void {
		this.config = this.dialogService.configurate()
	}
	ngOnDestroy(): void {
		this.subscriptions.forEach(subscription => {
			subscription.unsubscribe()
		})
	}
	// <- end HOOKS

	maximize(event: MouseEvent) {
		if (this.fullScreen) {
			this.dialogRef.updateSize(this.config.width, this.config.height)
			this.fullScreen = false
		} else {
			this.fullScreen = true
			this.dialogRef.updateSize('99vw', '99vh')
		}
	}
	minimize(event: MouseEvent) {
		console.log(this.__backdropElement__(event))
		this.dialogService.addMinimizeTab({
			id: uniqueId('minimize_'),
			title: this.title,
			dialogRef: this.dialogRef,
			backdropElement: this.__backdropElement__(event)
		})
		this.dialogRef.addPanelClass('d-none')
	}
	
	setTitle(title:any,subtitle?:any) {
        
        this.title=title;
        if (subtitle)
            this.subtitle=subtitle;
        console.log('title BaseDialogComponent',this.title,this.subtitle);    
        this.changeDetectorRef.detectChanges();
    }
	
	refreshDialog() {
        this.changeDetectorRef.detectChanges();
    }
	private __backdropElement__(event: MouseEvent): HTMLElement {
		const current = event.currentTarget as HTMLElement
		const parent = current.parentElement.closest('mat-dialog-container')
		console.log(parent.parentElement.parentElement)
		return parent.parentElement.parentElement.previousElementSibling as HTMLElement
	}
    
}
